import { render } from "./StatsBar.vue?vue&type=template&id=77924127"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__